import React, { useState, useEffect } from "react";
import { withRouter, useHistory  } from "react-router-dom";
import { FaBuilding } from "react-icons/fa";
import Layout from "../../components/Layout";
import { apiCRMv3 } from "../../services/api";
import * as moment from "moment-timezone";
import Swal from "sweetalert2";

const SeniorRegional = (props) => {
    const navigate = useHistory();
    const [loaded, setLoaded] = useState(true);

    const cards = [
        { title: "Regional 01", data: "R01" },
        { title: "Regional 02", data: "R02" },
        { title: "Regional 03", data: "R03" },
        { title: "Regional 04", data: "R04" },
        { title: "Regional 05", data: "R05" },
        { title: "Regional 06", data: "R06" },
        { title: "Regional 07", data: "R07" },
        { title: "Regional 08", data: "R08" },
        { title: "Regional 09", data: "R09" },
        { title: "Regional 10", data: "R10" },
        { title: "Regional 11", data: "R11" },
        { title: "Regional 12", data: "R12" },
        { title: "Regional 13", data: "R13" },
        { title: "Regional 14", data: "R14" },
        { title: "Regional 15", data: "R15" },
    ];

    async function getReportCrmDataRegional() {
        try {
            const start = moment.tz("America/Sao_Paulo").startOf("month").format("YYYY-MM-DD");
            const end = moment.tz("America/Sao_Paulo").endOf("month").format("YYYY-MM-DD");
            setLoaded(false);
            const response = await apiCRMv3.get(`/crm-analysis/export-all-branches`, {
                params: {
                    start,
                    end
                },
                responseType: 'blob'
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `dados_crm_regional_por_filiais.xlsx`); // nome do arquivo
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);

            Swal.fire("Sucesso!", "O relatório foi baixado com sucesso!", "success");

            setLoaded(true);

        } catch (err) {
            console.log(err);
            Swal.fire("Erro!", "Problemas ao gerar o relatório. Por favor contate o suporte!", "error");
            setLoaded(true);
        }
    }
    return (
        <Layout menuActive="registers" pageTitle="Dados Regional">
            <div className="row">
                <div className="col-xs-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="card-title">Dados Regional</div>
                        </div>
                        <div className={`card-body ${loaded ? "" : "__loading"}`}>
                            <div className="row" style={{ marginLeft: "50px", alignItems: "center", justifyContent: "center" }}>
                                <div style={{ marginBottom: "20px", display: "flex", justifyContent: "flex-start", gap: "10px" }}>
                                    <button className="btn btn-success btn-large"
                                        type="button" onClick={(e) => {
                                            getReportCrmDataRegional()
                                        }}>
                                        Exportar Dados
                                    </button>
                                </div>
                            </div>
                            <br></br>
                            <div style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "20px",
                                alignItems: "flex-start",
                                justifyContent: "center",
                                padding: "20px",
                            }}>
                                {/* Coluna dos Cards */}
                                <div style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "20px",
                                    alignItems: "flex-start",
                                    justifyContent: "center",
                                    padding: "20px",
                                }}>
                                    {cards.map((card, i) => (
                                        <div
                                            key={i}
                                            style={{
                                                background: "#fff",
                                                borderRadius: "12px",
                                                padding: "20px",
                                                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                                                transition: "transform 0.2s",
                                                cursor: "pointer",
                                                width: "200px", // define uma largura fixa para alinhar bem
                                                textAlign: "center",
                                            }}
                                            onMouseEnter={e => e.currentTarget.style.transform = "scale(1.05)"}
                                            onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"}
                                            onClick={() => navigate.push(`/branches-regional-crm?regional=${card.data}`)}
                                        >
                                            <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                                                <FaBuilding size={20} color="#095077" style={{ marginRight: "10px" }} />
                                                <h3 style={{ margin: 0 }}>{card.title}</h3>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default withRouter(SeniorRegional);

